import styled from "@emotion/styled";

import SvgTooltipArrow from "./icon-tooltip-arrow.svg";

export const Container = styled.div`
  position: absolute;
  inset-block-end: 26px;
  inset-inline-start: 0;

  inline-size: 100%;
  padding-block: 12px;
  padding-inline: 20px;
  box-sizing: border-box;

  white-space: normal;

  border-radius: 4px;

  background: #000000a6;
`;

export const TooltipsContent = styled.div`
  inline-size: inherit;
  block-size: inherit;

  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.41px;
`;

export const StyledTooltipsInfoArrow = styled(SvgTooltipArrow)`
  position: absolute;
  inset-block-start: -8px;
  inset-inline-start: 50%;

  transform: translateX(-50%);
`;
